import { Modal } from "react-bootstrap";
import { BsXLg } from "react-icons/bs";

export default function PrivacyModal(props) {
  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      centered
      className="privacy-modal"
    >
      <Modal.Header>
        <Modal.Title>개인정보 수집 및 이용 동의(담다CRM)</Modal.Title>
        <button
          className="btn close-btn"
          style={{ fontSize: "1.3rem", padding: "0.5rem 1rem" }}
          onClick={() => props.onHide()}
        >
          <BsXLg />
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="info-collect-agreement">
          <small>
            <b style={{ textDecoration: "underline" }}>
              개인정보 수집 및 이용 동의
            </b>
          </small>
          <ul className="mt-2">
            <li type="none">
              <small>
                <b>1. 수집목적: </b> 쿠폰과 포인트 적립 서비스 제공
              </small>
            </li>
            <li type="none">
              <small>
                <b>2. 수집항목</b>
              </small>
              <li type="circle" className="ml-4">
                <small>필수 항목 - 연락처</small>
              </li>
              <li type="circle" className="ml-4">
                <small>선택 항목 - 이름, 생년월일, 성별, 비밀번호</small>
              </li>
              <li type="circle" className="ml-4">
                <small>보유 기간 - 회원 가입 시부터 회원 탈퇴시까지</small>
              </li>
            </li>
          </ul>
          <div></div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn c-btn-primary btn-primary"
          onClick={() => {
            props.okPrivacy();
            props.onHide();
          }}
        >
          확인
        </button>
      </Modal.Footer>
    </Modal>
  );
}
